import moment from 'moment';
import { useMemo } from 'react';
import '../style.css';

function CalendarDays({ currentDay, changeCurrentDay, markedDates }) {
	const firstDayOfMonth = new Date(currentDay.getFullYear(), currentDay.getMonth(), 1);
	const weekdayOfFirstDay = firstDayOfMonth.getDay();

	const currentDays = useMemo(() => {
		const daysArray = [];

		for (let day = 0; day < 42; day++) {
			if (day === 0 && weekdayOfFirstDay === 0) {
				firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 7);
			} else if (day === 0) {
				firstDayOfMonth.setDate(firstDayOfMonth.getDate() + (day - weekdayOfFirstDay));
			} else {
				firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);
			}

			let countMarkedDates = 0;
			if (markedDates?.length > 0) {
				countMarkedDates = markedDates.reduce((prev, current) => {
					const currentMarkedDate = moment(current);
					if (!currentMarkedDate) return 0;
					const dayOfMonth = moment(firstDayOfMonth);
					const isSame = currentMarkedDate.isSame(dayOfMonth, 'day');
					return isSame ? prev + 1 : prev;
				}, 0);
			}

			if (countMarkedDates > 5) countMarkedDates = 5;
			const calendarDay = {
				currentMonth: firstDayOfMonth.getMonth() === currentDay.getMonth(),
				date: new Date(firstDayOfMonth),
				month: firstDayOfMonth.getMonth(),
				day: firstDayOfMonth.getDate(),
				selected: firstDayOfMonth.toDateString() === currentDay.toDateString(),
				year: firstDayOfMonth.getFullYear(),
				countMarkedDates,
			};
			daysArray.push(calendarDay);
		}
		return daysArray;
	}, [currentDay, markedDates]);

	const _renderDay = day => {
		const dots = [...Array(day.countMarkedDates).keys()];
		return (
			<div
				key={day.date.toLocaleString()}
				className={'Calendar__day' + (day.currentMonth ? '__current' : '') + (day.selected ? ' selected' : '')}
				onClick={() => changeCurrentDay(day)}
			>
				<span className="number">{day.day}</span>
				<div className="dots">
					{dots.map((dot, idx) => (
						<span className="dot" key={idx}></span>
					))}
				</div>
			</div>
		);
	};

	return <div className="CalendarDays">{currentDays.map(_renderDay)}</div>;
}

export default CalendarDays;
